import type { RecoverSettings } from "@redotech/redo-marketing-settings-common/recover-settings";
import * as z from "zod";

export const ShopperAgentHumanQueueConfigSchema = z.object({
  enabled: z.boolean().nullish(),
});

export type ShopperAgentHumanQueueConfig = z.infer<
  typeof ShopperAgentHumanQueueConfigSchema
>;

type LoosePick<T, K extends keyof T> = { [P in K]?: T[P] | null };

/**
 * Formerly "recover" (misnamed after the Recover product, which merely uses
 * the queue). The view field still uses `recoverConfig`.
 */
export interface ShopperAgentHumanQueueSettings {
  recover?: LoosePick<RecoverSettings, "useSharedNumber"> | null;
  /** Published CRDB settings slice — assemble via `getCrdbShopperAgentSettingsView`. */
  shopperAgent?:
    | ({ enabled?: boolean | null } & {
        recoverConfig?: LoosePick<
          ShopperAgentHumanQueueConfig,
          "enabled"
        > | null;
      })
    | null;
}

export function isShopperAgentHumanQueueEnabled(
  settings: ShopperAgentHumanQueueSettings | null | undefined,
): boolean {
  return (
    settings?.shopperAgent?.enabled === true &&
    settings.shopperAgent.recoverConfig?.enabled === true
  );
}

/**
 * The Recover product's shared-number toggle — a Recover setting, not a
 * shopper-agent one, so it keeps the Recover name.
 */
export function isSharedRecoverNumberEnabled(
  settings: ShopperAgentHumanQueueSettings | null | undefined,
): boolean {
  return settings?.recover?.useSharedNumber === true;
}
